var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.5 736",
    style: {
      enableBackground: "new 0 0 728.5 736"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#202028;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M723.7,11.4c-9.2-9.2-24.2-9.2-33.5,0L366.4,335.3L41.8,10.7c-9.2-9.2-24.2-9.2-33.5,0 c-9.2,9.2-9.2,24.2,0,33.5l324.6,324.6L9.1,692.6c-9.2,9.2-9.2,24.2,0,33.5c4.6,4.6,10.7,6.9,16.7,6.9s12.1-2.3,16.7-6.9 l323.8-323.8l323.1,323.1c4.6,4.6,10.7,6.9,16.7,6.9c6.1,0,12.1-2.3,16.7-6.9c9.2-9.2,9.2-24.2,0-33.5L399.9,368.8L723.7,44.9 C732.9,35.7,732.9,20.7,723.7,11.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.469a09d0.svg";
export { ForwardRef as ReactComponent };